import { createSlice } from "@reduxjs/toolkit";


const types = {
  noExt: 'street_number',
  address: 'route',
  colony: 'political',
  municipality: 'locality',
  state: 'administrative_area_level_1',
  country: 'country',
  postal_code: 'postal_code'
}
const initialState = {
  value: '',
  street: '',
  extNumber: '',
  intNumber: '',
  colony: '',
  postalCode: '',
  state: '',
  city: '',
  country: '',
  service: '',
  reference: '',
  name: '',
  receiver: '',
  defaultAddressInvoice: false,
  latitude: 0.0,
  longitude: 0.0,
  addressType: ''
}
export const fillAddressSlice = createSlice({
  name: "fill-address",
  initialState: {...initialState},
  reducers: {
    fillAddress: (state, action) => {

    },
    autoFillAddress: (state, action) => {
      
      return {
        ...state,
        ...action.payload,
      }
    },
    setTypeService: (state, {payload}) => {
      state.service = payload.type
    },
    resetForm: (state) => {
      return initialState
    }
  }
})

export const { fillAddress, autoFillAddress, resetForm, setTypeService } = fillAddressSlice.actions